import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core'

// jscpd:ignore-start



@Component({
    selector: 'app-mobile-validation-popup',
    templateUrl: './mobile-validation.component.html',
    styleUrls: ['./mobile-validation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MobileValidationComponent implements OnInit {
  constructor() {}

  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Output() closed: EventEmitter<unknown> = new EventEmitter()

  close() {
    this.closed.emit(true)
  }

  ngOnInit(): void {
  }
// jscpd:ignore-end

}
